module.exports = __webpack_public_path__ + "static/media/textediter_bold.7b812ad9.svg";